// BuildingDetailsHeatingSystemsAdd.js
import React, { useEffect, useState } from 'react';
import {
    Box, TextField, Button, Typography, Stack, MenuItem
} from '@mui/material';
import axios from 'axios';

const systemOptions = ["natural_gas", "oil", "electricity"];

const BuildingDetailsHeatingSystemsAdd = ({ buildingId, system, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        system_type: '',
        efficiency: '',
        fuel_cost: ''
    });

    useEffect(() => {
        if (system) {
            setFormData({
                system_type: system.system_type,
                efficiency: system.efficiency,
                fuel_cost: system.fuel_cost
            });
        }
    }, [system]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            efficiency: parseFloat(formData.efficiency),
            fuel_cost: parseFloat(formData.fuel_cost)
        };

        const url = system
            ? `/buildings/${buildingId}/heating-systems/${system.id}/`
            : `/buildings/${buildingId}/heating-systems/`;

        const method = system ? axios.put : axios.post;

        method(url, payload)
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => {
                onError();
            });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>
                {system ? 'Edit Heating System' : 'Add Heating System'}
            </Typography>

            <Stack spacing={2}>
                <TextField
                    select
                    label="System Type"
                    name="system_type"
                    value={formData.system_type}
                    onChange={handleChange}
                    required
                    fullWidth
                    disabled={!!system}
                >
                    <MenuItem value="natural_gas">Natural Gas</MenuItem>
                    <MenuItem value="oil">Oil Boiler</MenuItem>
                    <MenuItem value="electricity">Electricity</MenuItem>
                </TextField>


                <TextField
                    label="Efficiency"
                    name="efficiency"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    fullWidth
                    required
                    value={formData.efficiency}
                    onChange={handleChange}
                />
                <TextField
                    label="Fuel Cost"
                    name="fuel_cost"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    fullWidth
                    required
                    value={formData.fuel_cost}
                    onChange={handleChange}
                />

                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="outlined" color="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" type="submit">
                        {system ? 'Save' : 'Add'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};

export default BuildingDetailsHeatingSystemsAdd;
